<template>
  <div id="app">
  <main class="main-body">
    <topbar @clicked="onClickChild"></topbar>
      <router-view></router-view>
    <footbar></footbar>
  </main>  
  </div>
</template>

<script>
import Topbar from './components/layout/Topbar.vue'
import Footbar from './components/layout/Footbar.vue'
export default {
  name: 'app',
  data () {
    return {
      data: []
    }
  },
  components: {
    Topbar,
    Footbar
  },
  mounted: function () {
  },
  methods: {
    onClickChild (value) {
      console.log(value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// App.vue?63265416